import { render, staticRenderFns } from "./ParentCard.vue?vue&type=template&id=17ecdc2f&scoped=true&"
import script from "./ParentCard.vue?vue&type=script&lang=js&"
export * from "./ParentCard.vue?vue&type=script&lang=js&"
import style0 from "./ParentCard.vue?vue&type=style&index=0&id=17ecdc2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ecdc2f",
  null
  
)

export default component.exports